import { ATS_PLANS, TSE_PLANS, BUNDLE_PLANS } from './featureFlags';

export const PRICING_PRODUCTS = ['ats', 'tse', 'bundle'];
export const PRICING_PLANS = { ats: ATS_PLANS, tse: TSE_PLANS, bundle: BUNDLE_PLANS };
export const PRICING_SALES_URL = 'https://calendly.com/jobseeqr-1-on-1/intro-meeting';

export const getPricingPlans = (product, requiredFeature) => {
  const plans = Object.values(PRICING_PLANS[product] || {}).filter(plan => !plan.contactSales);
  if (!requiredFeature) return plans;
  // Unmapped features should not leave an empty purchase screen.
  const isKnownFeature = Object.values(PRICING_PLANS).some(catalog =>
    Object.values(catalog).some(plan => !plan.contactSales && requiredFeature in plan.features));
  return isKnownFeature ? plans.filter(plan => Boolean(plan.features[requiredFeature])) : plans;
};

export const getPlanCredits = plan => plan.credits || plan.features?.tseCredits || 0;

export const getPlanBilling = (plan, period) => ({
  monthlyEquivalent: period === 'yearly' ? plan.priceYearly / 12 : plan.priceMonthly,
  total: period === 'yearly' ? plan.priceYearly : plan.priceMonthly,
  savings: plan.priceMonthly * 12 - plan.priceYearly,
});

export const buildPricingCheckout = ({ plan, productType, billingPeriod, successUrl, cancelUrl }) => {
  const configured = PRICING_PLANS[productType]?.[plan?.id];
  const priceId = configured?.stripe?.[billingPeriod];
  if (!['monthly', 'yearly'].includes(billingPeriod) || !priceId || /^price_[A-Z_]+$/.test(priceId)) {
    throw new Error('invalid-pricing-plan');
  }
  return {
    productType, priceId, successUrl, cancelUrl, trialDays: 0,
    metadata: {
      planId: configured.id,
      billingPeriod,
      billingType: billingPeriod,
      credits: getPlanCredits(configured),
      subscriptionName: configured.metadata?.subscriptionName || configured.displayName,
    },
  };
};
